import { cn } from "@/lib/utils";
import { ReactNode } from "react";

interface MobileListItemHeaderProps {
  title: string;
  subtitle?: string;
  badge?: ReactNode;
  className?: string;
}

export function MobileListItemHeader({
  title,
  subtitle,
  badge,
  className,
}: MobileListItemHeaderProps) {
  return (
    <div
      className={cn("flex items-start justify-between gap-3 mb-2", className)}
    >
      <div className="flex-1 min-w-0">
        <h3 className="text-base font-medium text-gray-900 truncate">
          {title}
        </h3>
        {subtitle && (
          <p className="text-sm text-gray-500 mt-1 truncate">{subtitle}</p>
        )}
      </div>
      {badge && <div className="flex-shrink-0">{badge}</div>}
    </div>
  );
}
